import { render, staticRenderFns } from "./CbxOccupation.vue?vue&type=template&id=5758b79d&"
import script from "./CbxOccupation.vue?vue&type=script&lang=ts&"
export * from "./CbxOccupation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports